<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="用户ID" v-if="query.userId">
          <el-input v-model="query.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="所在城市">
          <el-select v-model="query.cityCode" placeholder="全部城市" clearable filterable style="width: 180px">
            <el-option
              v-for="item in cityOptions"
              :key="item.cityCode"
              :label="item.cityName"
              :value="item.cityCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select v-model="query.isTop" placeholder="请选择" clearable style="width: 120px">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否推荐">
          <el-select v-model="query.isRecommend" placeholder="请选择" clearable style="width: 120px">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择" clearable>
            <el-option label="已发布" value="PUBLISHED"></el-option>
            <el-option label="已下架" value="OFFLINE"></el-option>
            <el-option label="待审核" value="PENDING_APPROVAL"></el-option>
            <el-option label="词审驳回" value="WORD_REJECTED"></el-option>
            <el-option label="AI驳回" value="AI_REJECTED"></el-option>
            <el-option label="人工驳回" value="REJECTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="query.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="标题" min-width="220" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div class="title-with-tags">
              <el-tag v-if="isTop(row)" type="danger" size="mini" effect="dark">置顶</el-tag>
              <el-tag v-if="isRecommend(row)" type="warning" size="mini" effect="dark">推荐</el-tag>
              <span class="title-text">{{ row.title || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发布者" width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.userNickname || row.username || row.nickname || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="帖子类型" width="90">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.postType === 'DEMAND' ? 'warning' : 'success'">
              {{ postTypeText(row.postType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="分类" width="100"></el-table-column>
        <el-table-column prop="cityName" label="所在城市" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">
              {{ statusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="viewCount" label="浏览" width="70"></el-table-column>
        <el-table-column prop="createTime" label="发布时间" width="160"></el-table-column>
        <el-table-column prop="validUntil" label="到期时间" width="160"></el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <el-button v-if="isPublished(row.status)" type="text" style="color: #E6A23C" @click="handleOffline(row)">下架</el-button>
            <el-button v-if="isOffline(row.status)" type="text" style="color: #67C23A" @click="handleOnline(row)">上架</el-button>
            <el-button type="text" @click="handleToggleTop(row)">
              {{ isTop(row) ? '取消置顶' : '置顶' }}
            </el-button>
            <el-button type="text" @click="handleToggleRecommend(row)">
              {{ isRecommend(row) ? '取消推荐' : '推荐' }}
            </el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="帖子详情" :visible.sync="detailVisible" width="960px">
      <div v-if="currentPost" class="post-detail-panel">
        <el-descriptions border :column="2">
          <el-descriptions-item label="ID">{{ currentPost.id }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="statusTagType(currentPost.status)" size="small">{{ statusText(currentPost.status) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="标题" :span="2">{{ currentPost.title || '-' }}</el-descriptions-item>
          <el-descriptions-item label="内容" :span="2">
            <div class="post-content-block">{{ postContentText }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="发布者">
            {{ currentPost.userNickname || currentPost.username || currentPost.nickname || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="手机号">
            {{ currentPost.userMobile || currentPost.mobile || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="头像">
            <el-avatar
              v-if="currentPost.userAvatar"
              :src="currentPost.userAvatar"
              size="small"
            ></el-avatar>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="帖子类型">{{ postTypeText(currentPost.postType) }}</el-descriptions-item>
          <el-descriptions-item label="发布时效">{{ currentPost.durationDays ? currentPost.durationDays + ' 天' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="分类">
            {{ currentPost.parentCategoryName ? currentPost.parentCategoryName + ' > ' : '' }}{{ currentPost.categoryName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="城市">{{ currentPost.cityName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ currentPost.regionName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="地址" :span="2">{{ currentPost.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="价格">{{ formatPrice(currentPost.priceAmount || currentPost.price) }}</el-descriptions-item>
          <el-descriptions-item label="发帖结算价">{{ formatPrice(currentPost.publishFeeAmount) }}</el-descriptions-item>
          <el-descriptions-item label="免费额度抵扣">{{ Number(currentPost.freeQuotaUsed || 0) === 1 ? '是' : '否' }}</el-descriptions-item>
          <el-descriptions-item label="帖子电话">{{ currentPost.contactPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{ currentPost.contactWechat || '-' }}</el-descriptions-item>
          <el-descriptions-item label="小红书号">{{ currentPost.contactXiaohongshu || '-' }}</el-descriptions-item>
          <el-descriptions-item label="抖音号">{{ currentPost.contactDouyin || '-' }}</el-descriptions-item>
          <el-descriptions-item label="浏览数">{{ currentPost.viewCount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="收藏数">{{ currentPost.favoriteCount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="聊天数">{{ currentPost.chatCount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="发布时间">{{ currentPost.publishedTime || currentPost.createTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="到期时间">{{ currentPost.validUntil || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下架时间">{{ currentPost.offlineTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentPost.createTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{ currentPost.updateTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核状态">{{ auditStateText(currentPost.wordAuditStatus, currentPost.aiAuditStatus) }}</el-descriptions-item>
          <el-descriptions-item label="拒绝原因" :span="2">{{ currentPost.rejectReason || '-' }}</el-descriptions-item>
        </el-descriptions>

        <el-card style="margin-top: 16px" shadow="never">
          <div slot="header">媒体内容</div>
          <div v-if="imageMediaList.length" class="media-grid">
            <div v-for="media in imageMediaList" :key="media.id || media.mediaUrl" class="media-item">
              <el-image
                :src="media.mediaUrl"
                :preview-src-list="imagePreviewList"
                fit="cover"
                class="media-thumb"
              ></el-image>
            </div>
          </div>
          <el-empty v-else description="暂无媒体内容"></el-empty>
        </el-card>

        <el-card style="margin-top: 16px" shadow="never">
          <div slot="header">审核记录</div>
          <el-table :data="auditRecords" border stripe size="mini" v-if="auditRecords.length">
            <el-table-column prop="auditType" label="审核类型" width="120"></el-table-column>
            <el-table-column prop="auditResult" label="结果" width="100"></el-table-column>
            <el-table-column prop="riskType" label="风险类型" width="120"></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="auditorId" label="审核人" width="100"></el-table-column>
            <el-table-column prop="createTime" label="时间" width="160"></el-table-column>
          </el-table>
          <el-empty v-else description="暂无审核记录"></el-empty>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPosts, getPostDetail, offlinePost, onlinePost, deletePost, setPostTop, setPostRecommend, getCities } from '../../api'

export default {
  name: 'PostManage',
  data() {
      return {
      query: { title: '', userId: '', cityCode: '', status: '', isTop: '', isRecommend: '', dateRange: [], page: 1, pageSize: 10 },
      list: [], total: 0, loading: false,
      detailVisible: false, currentPost: null,
      cityOptions: []
      }
    },
  computed: {
    mediaList() {
      return Array.isArray(this.currentPost && this.currentPost.mediaList) ? this.currentPost.mediaList : []
    },
    imageMediaList() {
      return this.mediaList.filter(item => this.isImageMedia(item))
    },
    auditRecords() {
      return Array.isArray(this.currentPost && this.currentPost.auditRecords) ? this.currentPost.auditRecords : []
    },
    imagePreviewList() {
      return this.imageMediaList.map(item => item.mediaUrl).filter(Boolean)
    },
    postContentText() {
      if (!this.currentPost) return '-'
      return this.currentPost.content || this.currentPost.description || this.currentPost.postContent || this.currentPost.detailContent || '-'
    }
  },
  created() {
    this.syncRouteQuery()
    this.loadCities()
    this.fetchList()
  },
  beforeRouteUpdate(to, from, next) {
    this.query.userId = to.query && to.query.userId != null ? String(to.query.userId) : ''
    this.query.page = 1
    this.fetchList()
    next()
  },
  methods: {
    syncRouteQuery() {
      const userId = this.$route && this.$route.query ? this.$route.query.userId : ''
      this.query.userId = userId != null && userId !== '' ? String(userId) : ''
    },
    loadCities() {
      getCities({ page: 1, pageSize: 500 }).then(res => {
        this.cityOptions = res.data.records || res.data || []
      }).catch(() => {
        this.cityOptions = []
      })
    },
    fetchList() {
      this.loading = true
      const params = {
        ...this.query,
        pageNum: this.query.page,
        pageSize: this.query.pageSize
      }
      delete params.page
      if (Array.isArray(params.dateRange) && params.dateRange.length === 2) {
        params.startTime = params.dateRange[0]
        params.endTime = params.dateRange[1]
      }
      delete params.dateRange
      if (!params.userId) {
        delete params.userId
      }
      if (!params.cityCode) {
        delete params.cityCode
      }
      if (params.isTop === '' || params.isTop === null || params.isTop === undefined) {
        delete params.isTop
      }
      if (params.isRecommend === '' || params.isRecommend === null || params.isRecommend === undefined) {
        delete params.isRecommend
      }
      getPosts(params).then(res => {
        this.list = res.data.records || res.data || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.query.page = 1; this.fetchList() },
    reset() {
      this.query = { title: '', userId: '', cityCode: '', status: '', isTop: '', isRecommend: '', dateRange: [], page: 1, pageSize: 10 }
      this.fetchList()
    },
    handleDetail(row) {
      getPostDetail(row.id).then(res => {
        this.currentPost = res.data || {}
        this.detailVisible = true
      })
    },
    statusTagType(status) {
      if (status === 1 || status === '1' || status === 'PUBLISHED') return 'success'
      if (status === 2 || status === '2' || status === 'PENDING_APPROVAL' || status === 'WORD_CHECKING' || status === 'AI_CHECKING' || status === 'EDIT_REVIEWING' || status === 'DRAFT') return 'warning'
      if (status === 'WORD_REJECTED' || status === 'AI_REJECTED' || status === 'REJECTED' || status === 'EDIT_REJECTED' || status === 'DELETED') return 'danger'
      if (status === 'OFFLINE') return 'info'
      return 'info'
    },
    statusText(status) {
      if (status === 1 || status === '1' || status === 'PUBLISHED') return '已发布'
      if (status === 2 || status === '2' || status === 'PENDING_APPROVAL' || status === 'WORD_CHECKING' || status === 'AI_CHECKING' || status === 'EDIT_REVIEWING') return '待审核'
      if (status === 'DRAFT') return '草稿'
      if (status === 'OFFLINE' || status === 0 || status === '0') return '已下架'
      if (status === 'WORD_REJECTED') return '违规词驳回'
      if (status === 'AI_REJECTED') return 'AI驳回'
      if (status === 'EDIT_REJECTED') return '编辑驳回'
      if (status === 'REJECTED') return '已驳回'
      if (status === 'DELETED') return '已删除'
      return status || '-'
    },
    postTypeText(postType) {
      if (postType === 'SUPPLY') return '供给帖'
      if (postType === 'DEMAND') return '需求帖'
      return postType || '-'
    },
    formatPrice(price) {
      const value = Number(price)
      if (!Number.isFinite(value)) return '-'
      return value > 0 ? `¥${(value / 100).toFixed(2)}` : '面议'
    },
    auditStateText(wordStatus, aiStatus) {
      const parts = []
      if (wordStatus) parts.push(`词审:${wordStatus}`)
      if (aiStatus) parts.push(`AI:${aiStatus}`)
      return parts.length ? parts.join(' / ') : '-'
    },
    isImageMedia(media) {
      const type = String(media && media.mediaType ? media.mediaType : '').toUpperCase()
      if (type.includes('IMAGE')) return true
      if (type.includes('PICTURE') || type.includes('PHOTO')) return true
      const url = String(media && media.mediaUrl ? media.mediaUrl : '').toLowerCase()
      return /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/.test(url)
    },
    isPublished(status) {
      return status === 1 || status === '1' || status === 'PUBLISHED'
    },
    isOffline(status) {
      return status === 0 || status === '0' || status === 'OFFLINE'
    },
    isTop(row) {
      return row && (row.isTop === 1 || row.isTop === '1')
    },
    isRecommend(row) {
      return row && (row.isRecommend === 1 || row.isRecommend === '1')
    },
    handleOffline(row) {
      this.$confirm('确定要下架该帖子吗？', '提示', { type: 'warning' }).then(() => {
        offlinePost(row.id).then(() => { this.$message.success('已下架'); this.fetchList() })
      }).catch(() => {})
    },
    handleOnline(row) {
      onlinePost(row.id).then(() => { this.$message.success('已上架'); this.fetchList() })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该帖子吗？', '提示', { type: 'warning' }).then(() => {
        deletePost(row.id).then(() => { this.$message.success('已删除'); this.fetchList() })
      }).catch(() => {})
    },
    handleToggleTop(row) {
      const text = this.isTop(row) ? '取消置顶' : '置顶'
      this.$confirm(`确定要${text}该帖子吗？`, '提示', { type: 'warning' }).then(() => {
        setPostTop(row.id).then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
      }).catch(() => {})
    },
    handleToggleRecommend(row) {
      const text = this.isRecommend(row) ? '取消推荐' : '推荐'
      this.$confirm(`确定要${text}该帖子吗？`, '提示', { type: 'warning' }).then(() => {
        setPostRecommend(row.id).then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.post-detail-panel {
  max-height: 70vh;
  overflow-y: auto;
}

.post-content-block {
  white-space: pre-wrap;
  line-height: 1.8;
  color: #303133;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.media-item {
  width: 120px;
}

.media-thumb {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  display: block;
}

.media-file {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  color: #909399;
}

.title-with-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.title-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
